import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import { Modal, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import moment from "moment";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import {
  calculateDaysDifference,
  formatNumber,
  printData,
} from "../../../utility/CommonFunctions";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";

export default function AddLeaveModal({
  isOpen,
  onClose,
  EditLeaveData,
  setState,
  getLeave,
  getLeaveCount,
  getAttendance,
  state,
  Type = null,
  teamDate = null,
  fromBulkAtt = false,
  markAttendance = false,
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    watch,
    reset,
    setValue,
    getValues,
    setError,
    control
  } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState({
    file: null,
    imageUrl: null,
    deleteUrl: null,
    isDelete: false,
    leaveTypeList: [],
    isHalfday: false,
  });
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [date, setDate] = useState({
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  const type = watch("leaveType");

  const onSubmit = (data) => {
    // console.log('Form Data:', data);
    const postData = {
      ...(EditLeaveData !== null && { leaveId: EditLeaveData?.id }),
      ...(state?.userId && { userId: state?.userId }),
      title: data?.title,
      leaveType: data?.leaveType,
      contactNumber: data?.contactNumber,
      startDate: date?.startDate,
      endDate: date?.endDate,
      reason: data?.reason,
      url: file?.file,
      ...(file?.isDelete && { deleteDocument: file?.deleteUrl }),
      ...(file?.isHalfday
        ? {
          ...(data?.halfDayOption === "secondHalf"
            ? {
              leaveDuration: data?.halfDayOption,
            }
            : { leaveDuration: data?.halfDayOption }),
        }
        : { leaveDuration: "fullDay" }),
      ...(markAttendance && { from: "markAttendance" }),
    };

    // console.log("postData========>",postData);

    const formData = new FormData();
    Object.keys(postData).forEach((key) => {
      const value = postData[key];
      if (value) {
        // Check if the value exists before appending
        formData.append(key, value);
      }
    });

    const option = {
      method: "POST",
      form_data: formData, // Use 'body' for FormData
    };

    setIsLoading(true);

    const endPoint =
      EditLeaveData !== null ? apiUrl.update_leave : apiUrl.add_leave;
    // Call the API
    callApi(endPoint, option).then((res) => {
      setIsLoading(false);
      if (res?.status === true) {
        toast.success(res?.message);
        if (Type === null) {
          getLeave();
          getLeaveCount();
        }
        if (Type === "leaveForUser") {
          getAttendance();
        }
        onClose();
        reset();
        setFile({
          file: null,
          imageUrl: null,
          deleteUrl: null,
          isDelete: false,
          leaveTypeList: [],
          isHalfday: false,
        });
      } else {
        toast.error(res?.message);
      }
    });
  };

  const handleDeleteDocument = () => {
    setFile((pre) => ({
      ...pre,
      file: null,
      imageUrl: null,
      isDelete: EditLeaveData !== null ? !pre.isDelete : pre.isDelete,
    }));
  };

  useEffect(() => {
    if (state?.userName) {
      setValue(
        "startDate",
        moment(state?.sortBySingleDate[0]).format("YYYY-MM-DD")
      );
      setValue(
        "endDate",
        moment(state?.sortBySingleDate[0]).format("YYYY-MM-DD")
      );
      setDate((pre) => ({
        ...pre,
        startDate: moment(state?.sortBySingleDate[0]).format("YYYY-MM-DD"),
        endDate: moment(state?.sortBySingleDate[0]).format("YYYY-MM-DD"),
      }));
    }
    if (EditLeaveData !== null) {
      const startDate = moment(
        teamDate ? teamDate?.startDate : EditLeaveData?.startDate
      ).format("YYYY-MM-DD");
      const endDate = moment(
        teamDate ? teamDate?.endDate : EditLeaveData?.endDate
      ).format("YYYY-MM-DD");

      setValue("title", EditLeaveData?.title);
      setValue("leaveType", EditLeaveData?.leaveType);
      setValue("contactNumber", EditLeaveData?.contactNumber);
      setValue("startDate", startDate);
      setValue("endDate", endDate);
      setValue("reason", EditLeaveData?.reason);
      setValue(
        "halfDayLeave",
        EditLeaveData?.leaveDuration !== "fullDay"
          ? EditLeaveData?.leaveDuration
          : false
      );
      setValue("halfDayOption", EditLeaveData?.leaveDuration);
      setFile((pre) => ({
        ...pre,
        imageUrl: EditLeaveData?.url,
        deleteUrl: EditLeaveData?.url,
        isHalfday: EditLeaveData?.leaveDuration !== "fullDay" ? true : false,
      }));
    } else {
      reset();
    }

    if (teamDate || fromBulkAtt) {
      setValue("startDate", moment(teamDate).format("YYYY-MM-DD"));
    }

    if (fromBulkAtt) {
      setValue("startDate", moment(teamDate).format("YYYY-MM-DD"));
      setValue("endDate", moment(teamDate).format("YYYY-MM-DD"));
      setDate((prev) => ({
        ...prev,
        endDate: moment(teamDate).format("YYYY-MM-DD"),
        startDate: moment(teamDate).format("YYYY-MM-DD"),
      }));
    }

    // console.log("teamDate",teamDate)
  }, [EditLeaveData, isOpen]);

  return (
    <Modal
      className="modal-dialog modal-dialog-scrollable modal-xl modal-dialog-centered leave-modal"
      id="leaveModal"
      isOpen={isOpen}
      toggle={() => {
        clearErrors();
        onClose();
        setFile({
          file: null,
          imageUrl: null,
          deleteUrl: null,
          isDelete: false,
          leaveTypeList: [],
          isHalfday: false,
        });
        reset();
        if (Type === null) {
          setState((pre) => ({ ...pre, EditLeaveData: null }));
        }
      }}
    >
      <div className="modal-content">
        <div className="modal-header p-4 border-0">
          <h1
            className="modal-title fs-3 rajdhani-semibold"
            id="attendanceModalLabel"
          >
            {EditLeaveData !== null
              ? "Update Leave"
              : state?.userName
                ? `Applying Leave For ${state?.userName}`
                : "Apply for leave"}
          </h1>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              clearErrors();
              reset();
              if (Type === null) {
                setState((pre) => ({ ...pre, EditLeaveData: null }));
              }
              setFile({
                file: null,
                imageUrl: null,
                deleteUrl: null,
                isDelete: false,
                leaveTypeList: [],
                isHalfday: false,
              });

              onClose();
            }}
          />
        </div>
        <div className="modal-body p-4">
          <form id="leaveRequestForm" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-6">
                <div className="form-group mb-3">
                  <label htmlFor="holiday" className="form-label">
                    Title <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="holiday"
                    placeholder="Title"
                    {...register("title", { required: "Title is required" })}
                  />
                  {errors.title && (
                    <div className="form-text text-danger">
                      {errors.title.message}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-6">
                <div className="form-group mb-3">
                  <label htmlFor="typ" className="form-label d-flex">
                    Leave Type <span className="text-danger">*</span>
                    <span className="d-block ms-auto fs-5 lead">
                      Remaining Leaves{" "}
                      <span className="text-primary">
                        {(() => {
                          const leaveData = state?.listType?.find(
                            (item) => item?.leaveType === type
                          );
                          const remainingLeave = leaveData?.remainingLeave || 0;
                          const remainingDays = formatNumber(+remainingLeave);
                          return remainingDays || 0;
                        })()}
                      </span>{" "}
                    </span>
                  </label>
                  <select
                    className="form-select"
                    id="typ"
                    {...register("leaveType", {
                      required: "Leave type is required",
                    })}
                  >
                    <option value={""}>Select Leave Type</option>
                    {state?.listType &&
                      state?.listType?.length > 0 &&
                      state?.listType?.map((item, i) => {
                        return (
                          <option key={i} value={item?.leaveType}>
                            {item?.leaveType}
                          </option>
                        );
                      })}
                    {/* <option value="Casual Leave">Casual Leave</option>
                                        <option value="Earned Leave">Earned Leave</option>
                                        <option value="Compensatory Off">Compensatory Off</option> */}
                  </select>
                  {errors.leaveType && (
                    <div className="form-text text-danger">
                      {errors.leaveType.message}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-6">
                <div className="form-group mb-2">
                  <label htmlFor="holidayDate" className="form-label">
                    Contact Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="holidayDate"
                    placeholder="Contact Number"
                    {...register("contactNumber", {
                      // required: "Contact number is required",
                    })}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, "");
                    }}
                  />
                  {errors.contactNumber && (
                    <div className="form-text text-danger">
                      {errors.contactNumber.message}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-6">
                <div className="form-group h-100">
                  {/* Checkbox for Half Day Leave */}
                  <label htmlFor="leave" className="d-flex gap-2">
                    <input
                      type="checkbox"
                      id="leave"
                      role="button"
                      className=""
                      {...register("halfDayLeave", {
                        onChange: (e) => {
                          setFile((prev) => ({
                            ...prev,
                            isHalfday: e.target.checked, // Toggle isHalfday
                          }));
                        },
                      })}
                    />
                    <span>Half Day Leave ?</span>
                  </label>

                  {/* Conditional Radio Buttons */}
                  {file.isHalfday && (
                    <div className="d-flex justify-content-between mt-3">
                      {/* First Half Option */}
                      <div className="form-group ">
                        <label className="d-flex gap-2">
                          <input
                            type="radio"
                            name="halfDay" // Grouped radio buttons
                            value="firstHalf" // Unique value
                            className=""
                            {...register("halfDayOption", {
                              required: file.isHalfday
                                ? "Please select First or Second Half."
                                : false,
                            })}
                          />
                          <span>First Half</span>
                        </label>
                      </div>

                      {/* Second Half Option */}
                      <div className="form-group">
                        <label className="d-flex gap-2">
                          <input
                            type="radio"
                            name="halfDay" // Same group name
                            value="secondHalf" // Unique value
                            className=""
                            {...register("halfDayOption")}
                          />
                          <span>Second Half</span>
                        </label>
                      </div>
                    </div>
                  )}

                  {/* Validation Error Message for Radio Buttons */}
                  {errors.halfDayOption && (
                    <div className="form-text text-danger">
                      {errors.halfDayOption.message}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-6">
                <div className="form-group mb-3">
                  <label htmlFor="startDate" className="form-label">
                    Start Date <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="startDate"
                    control={control}
                    rules={{
                      required: "Start date is required",
                      validate: (value) => {
                        const checkDate = moment(value).startOf('day');
                        const today = moment().startOf('day');
                        // No specific past date restriction mentioned for leaves, but usually they shouldn't be too far in the past or future? 
                        // For now just keep it open or add basic check if needed.
                        return true;
                      }
                    }}
                    defaultValue={
                      state?.userName
                        ? moment(state?.sortBySingleDate[0]).format("YYYY-MM-DD")
                        : moment().format("YYYY-MM-DD")
                    }
                    render={({ field }) => (
                      <DatePicker size="sm"
                        {...field}
                        id="startDate"
                        format="dd/MM/yyyy"
                        oneTap
                        placeholder="dd/mm/yyyy"
                        style={{ width: "100%" }}
                        disabled={!!(state?.userName || fromBulkAtt)}
                        value={field.value ? new Date(field.value) : null}
                        onChange={(date) => {
                          const formattedDate = date ? moment(date).format("YYYY-MM-DD") : "";
                          field.onChange(formattedDate);
                          setDate((pre) => ({
                            ...pre,
                            startDate: formattedDate,
                            endDate: formattedDate,
                          }));
                          setValue("endDate", formattedDate);
                        }}
                        container={() => document.querySelector('.leave-modal .modal-content') || document.body}
                        cleanable={false}
                      />
                    )}
                  />
                  {errors.startDate && (
                    <div className="form-text text-danger">
                      {errors.startDate.message}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-6">
                <div className="form-group mb-3">
                  <label htmlFor="endDate" className="form-label">
                    End Date <span className="text-danger">*</span>
                  </label>
                  <Controller
                    name="endDate"
                    control={control}
                    rules={{
                      required: "End date is required",
                      validate: (value) => {
                        const start = getValues("startDate");
                        if (start && moment(value).isBefore(moment(start))) {
                          return "End date cannot be before start date";
                        }
                        return true;
                      }
                    }}
                    render={({ field }) => (
                      <DatePicker size="sm"
                        {...field}
                        id="endDate"
                        format="dd/MM/yyyy"
                        oneTap
                        placeholder="dd/mm/yyyy"
                        style={{ width: "100%" }}
                        value={field.value ? new Date(field.value) : null}
                        onChange={(date) => {
                          const formattedDate = date ? moment(date).format("YYYY-MM-DD") : "";
                          field.onChange(formattedDate);
                          setDate((pre) => ({
                            ...pre,
                            endDate: formattedDate,
                          }));
                        }}
                        shouldDisableDate={(d) => {
                          const start = date.startDate ? moment(date.startDate).startOf('day') : null;
                          return start && moment(d).isBefore(start);
                        }}
                        container={() => document.querySelector('.leave-modal .modal-content') || document.body}
                        cleanable={false}
                      />
                    )}
                  />
                  {errors.endDate && (
                    <div className="form-text text-danger">
                      {errors.endDate.message}
                    </div>
                  )}
                </div>
              </div>

              <p className="text-center">
                {calculateDaysDifference(date.startDate, date.endDate)}
              </p>

              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="desc" className="form-label">
                    Reason <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={3}
                    id="desc"
                    placeholder="Enter description here..."
                    {...register("reason", { required: "Reason is required" })}
                  />
                  {errors.reason && (
                    <div className="form-text text-danger">
                      {errors.reason.message}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="form-group mb-3">
                  <label htmlFor="desc" className="form-label">
                    Attachment
                  </label>
                  {!file?.imageUrl ? (
                    <input
                      type="file"
                      className="form-control"
                      id="desc"
                      placeholder="Choose File"
                      {...register("url")}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file && file.size > 6 * 1024 * 1024) {
                          toast.error("File size must be less than 6MB");
                          e.target.value = "";
                          return;
                        }
                        const imageUrl = file ? URL.createObjectURL(file) : "";
                        setFile((pre) => ({
                          ...pre,
                          file: file,
                          imageUrl: imageUrl,
                        }));
                        setError("url", "");
                      }}
                    />
                  ) : (
                    <div className="d-flex gap-4 align-items-center">
                      <div
                        className="d-flex gap-4 align-items-center mt-2"
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectedDocument(
                            EditLeaveData && !file.file
                              ? file.imageUrl
                              : file.file
                          );
                          toggleModal();
                        }}
                      >
                        <h4>
                          {EditLeaveData && !file.file
                            ? file.imageUrl
                            : file?.file?.name}
                        </h4>
                      </div>
                      <div className="">
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => {
                            handleDeleteDocument();
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  )}
                  {/* {errors.url && <div className="form-text text-danger">{errors.url.message}</div>} */}
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="modal-footer p-4 border-0">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              clearErrors();
              reset();
              setFile({
                file: null,
                imageUrl: null,
                deleteUrl: null,
                isDelete: false,
                leaveTypeList: [],
                isHalfday: false,
              });
              if (Type === null) {
                setState((pre) => ({ ...pre, EditLeaveData: null }));
              }
              onClose();
            }}
          >
            Close
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            form="leaveRequestForm"
          >
            {isLoading ? (
              <Spinner />
            ) : EditLeaveData !== null ? (
              "Update"
            ) : (
              "Apply"
            )}
          </button>
          {/* <button type="button" className="btn btn-primary">Save changes</button> */}
        </div>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </Modal>
  );
}
